import React, { useEffect } from 'react';
import logo from './QuestionStep/assets/TheFisrtDigiBank_Logo (1).png'
import { setNewAnswer, calculateResult, clearAllAnswer } from '../Store'
import CountUp from 'react-countup';
import './QuestionStep/style/Result.css'
import './QuestionStep/style/landing.css'
import star from './QuestionStep/assets/star.png'
import cloud1 from './QuestionStep/assets/calculator.png'
import cloud2 from './QuestionStep/assets/cloud3.png'
import facebook from './QuestionStep/assets/facebook.png'
import linkdin from './QuestionStep/assets/linkdin.png'
import mail from './QuestionStep/assets/mail.png'
import twit from './QuestionStep/assets/twit.png'
import whatsapp from './QuestionStep/assets/whatsapp.png'
import gifRresult from './QuestionStep/assets/10_megphone 2.gif'
import './Home.css'

import { useHistory } from 'react-router-dom'
import './Gif.css'

const ResultShare = () => {
    const history = useHistory();
    console.log("calculateResult 4");
    let theNumber = calculateResult();
    let yearsNumber = theNumber * 12;

    return (
        <>
            <div className="middle">
                <div className="res-middle">
                    <img id="cloud1" className="cloud" src={cloud1} alt="" />
                    <img id="cloud2" className="cloud3" src={cloud2} alt="" />
                    <img className="star rotate" src={star} alt="" />
                    <img className="star2 rotate2" src={star} alt="" />
                    <img className="star3 rotate3" src={star} alt="" />

                </div>
                <div className="question-container ">
                    <div className="resShareHold">
                        <img className="resShereRresult" src={gifRresult} alt="" />
                    </div>
                    <div className="reHeader">הבנק כנראה עולה לכם כ-</div>
                    <div className="numAndMonth">
                        <span className="number">
                            <span className="shah">₪</span>
                            <CountUp separator="," start={0} end={theNumber} delay={0} duration={2.75}>
                                {({ countUpRef }) => (
                                    <span>
                                        <span ref={countUpRef} />
                                    </span>
                                )}
                            </CountUp>
                        </span>
                        <span className="month"> בחודש </span>
                        <div className="yearAndNumber">
                            <span className="ke">כ-</span>
                            <span className="bigNumber">

                                <span>₪</span>

                                <CountUp separator="," start={0} end={yearsNumber} delay={0} duration={2.75}>
                                    {({ countUpRef }) => (
                                        <span>
                                            <span ref={countUpRef} />
                                        </span>
                                    )}
                                </CountUp>
                            </span>
                            <span className="year"> בשנה </span>
                        </div>
                    </div>
                    <div className="howTo">
                        <a className="linkColor" href="">איך חישבנו?</a>
                    </div>
                    <div className="betweenText">
                        בקרוב, עם פתיחת ההצטרפות לבנק הדיגיטלי הראשון,
                        <br/>
                        תתרגלו לשלם לבנק...הרבה פחות. מבטיחים.
                    </div>
                    <div className="soText">
                    שתפו את המחשבון עם חברים
                    </div>
                    <div className="Social">
                        
                        <a href=""><img className="whatsapp" width="20px" src={whatsapp} alt="" /></a>
                        <a href=""><img className="facebook" width="10px" src={facebook} alt="" /></a>
                        <a href=""><img className="linkdin" width="22px" src={linkdin} alt="" /></a>
                        <a href=""><img className="twit" width="22px" src={twit} alt="" /></a>
                        <a href=""><img className="mail" width="25px" src={mail} alt="" /></a>
                    </div>
                    <div className="reslogo">
                        <img width="110px" src={logo} alt="" />
                    </div>
                </div>
            </div>
        </>
    )
}



export default ResultShare

